import React, { useMemo, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { alertActions } from "../../_actions";
import { alertConstants } from "../../_constants";
import classes from "../assets/css/vessels.module.css";
import { encodeBase64 } from "tweetnacl-util";
import nacl from "tweetnacl";
import { vesselServices } from "../services/vessels.services";
import { decrypt, encrypt } from "../../_helpers";

export default function AssociateUserVessel({
  vesselId,
  toggle,
  show,
  isLoading = false,
  publicKey,
  privateKey,
}) {
  const { t } = useTranslation();
  const [userEmail, setUserEmail] = useState("");
  const dispatch = useDispatch();
  const [vessel, setVessel] = useState({});
  const [isApiLoading, setIsApiLoading] = useState(false);
  const user = useSelector((state) => state.authentication.user);

  useMemo(async () => {
    if (show && vesselId !== null && vesselId !== undefined) {
      const response = await vesselServices.getVesselById(vesselId);
      console.log(response?.vessel);
      const decryptPublicKey = response?.vessel?.isAssociated
        ? response?.vessel?.vesselPublicKey
        : publicKey;
      const decryptSecretKey = response?.vessel?.isAssociated
        ? response?.vessel?.vesselSecretKey
        : privateKey;

      const vessel = {
        isAssociated: response?.vessel?.isAssociated,
        sheetName: decrypt(
          response?.vessel?.sheetName,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselName: decrypt(
          response?.vessel?.vesselName,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselIMO: decrypt(
          response?.vessel?.vesselIMO,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselRegistryPort: decrypt(
          response?.vessel?.vesselRegistryPort,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselFlag: decrypt(
          response?.vessel?.vesselFlag,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselType: decrypt(
          response?.vessel?.vesselType,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselLOA: decrypt(
          `${response?.vessel?.vesselLOA}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselMaxPassengersWithStaterooms: decrypt(
          `${response?.vessel?.vesselMaxPassengersWithStaterooms}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselDayPassengersOnBoard: decrypt(
          `${response?.vessel?.vesselDayPassengersOnBoard}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProvider: decrypt(
          response?.vessel?.vesselServiceProvider,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderAddress: decrypt(
          response?.vessel?.vesselServiceProviderAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderCompany: decrypt(
          `${response?.vessel?.vesselServiceProviderCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderInsuranceRef: decrypt(
          response?.vessel?.vesselServiceProviderInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderVAT: decrypt(
          response?.vessel?.vesselServiceProviderVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgent: decrypt(
          response?.vessel?.vesselCentralAgent,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentAddress: decrypt(
          response?.vessel?.vesselCentralAgentAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentCompany: decrypt(
          `${response?.vessel?.vesselCentralAgentCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentInsuranceRef: decrypt(
          response?.vessel?.vesselCentralAgentInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentVAT: decrypt(
          response?.vessel?.vesselCentralAgentVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentMYBA: decrypt(
          response?.vessel?.vesselCentralAgentMYBA,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholder: decrypt(
          response?.vessel?.vesselStakeholder,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderAddress: decrypt(
          response?.vessel?.vesselStakeholderAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderCompany: decrypt(
          `${response?.vessel?.vesselStakeholderCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderInsuranceRef: decrypt(
          response?.vessel?.vesselStakeholderInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderMYBA: decrypt(
          response?.vessel?.vesselStakeholderMYBA,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderVAT: decrypt(
          response?.vessel?.vesselStakeholderVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderFinancialGuarantee: decrypt(
          response?.vessel?.vesselStakeholderFinancialGuarantee,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselSpecialConditions: decrypt(
          response?.vessel?.vesselSpecialConditions,
          decryptPublicKey,
          decryptSecretKey,
        ),
      };
      setVessel(vessel);
    }
  }, [vesselId, show]);
  const handleChange = (e) => {
    setUserEmail(e.target.value);
  };
  console.log(vessel);
  const handleSubmit = async () => {
    try {
      if (userEmail === user?.email) {
        dispatch(
          alertActions.setAlert(
            t("You cannot share a vessel with yourself"),
            alertConstants.ERROR,
          ),
        );
      } else {
        setIsApiLoading(true);
        let response = null;
        let keys = null;
        if (!vessel?.isAssociated) {
          const keyPair = nacl.box.keyPair();

          const vesselPublicKey = encodeBase64(keyPair.publicKey);
          const vesselSecretKey = encodeBase64(keyPair.secretKey);

          keys = {
            vesselPublicKey,
            vesselSecretKey,
          };

          const payload = {
            sheetName: encrypt(
              vessel?.sheetName,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselName: encrypt(
              vessel?.vesselName,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselIMO: encrypt(
              vessel?.vesselIMO,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselRegistryPort: encrypt(
              vessel?.vesselRegistryPort,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselFlag: encrypt(
              vessel?.vesselFlag,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselType: encrypt(
              vessel?.vesselType,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselLOA: encrypt(
              `${vessel?.vesselLOA}`,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselMaxPassengersWithStaterooms: encrypt(
              `${vessel?.vesselMaxPassengersWithStaterooms}`,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselDayPassengersOnBoard: encrypt(
              `${vessel?.vesselDayPassengersOnBoard}`,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselServiceProvider: encrypt(
              vessel?.vesselServiceProvider,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselServiceProviderAddress: encrypt(
              vessel?.vesselServiceProviderAddress,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselServiceProviderCompany: encrypt(
              `${vessel?.vesselServiceProviderCompany}`,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselServiceProviderInsuranceRef: encrypt(
              vessel?.vesselServiceProviderInsuranceRef,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselServiceProviderVAT: encrypt(
              vessel?.vesselServiceProviderVAT,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselCentralAgent: encrypt(
              vessel?.vesselCentralAgent,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselCentralAgentAddress: encrypt(
              vessel?.vesselCentralAgentAddress,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselCentralAgentCompany: encrypt(
              `${vessel?.vesselCentralAgentCompany}`,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselCentralAgentInsuranceRef: encrypt(
              vessel?.vesselCentralAgentInsuranceRef,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselCentralAgentVAT: encrypt(
              vessel?.vesselCentralAgentVAT,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselCentralAgentMYBA: encrypt(
              vessel?.vesselCentralAgentMYBA,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselStakeholder: encrypt(
              vessel?.vesselStakeholder,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselStakeholderAddress: encrypt(
              vessel?.vesselStakeholderAddress,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselStakeholderCompany: encrypt(
              `${vessel?.vesselStakeholderCompany}`,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselStakeholderInsuranceRef: encrypt(
              vessel?.vesselStakeholderInsuranceRef,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselStakeholderMYBA: encrypt(
              vessel?.vesselStakeholderMYBA,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselStakeholderVAT: encrypt(
              vessel?.vesselStakeholderVAT,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselStakeholderFinancialGuarantee: encrypt(
              vessel?.vesselStakeholderFinancialGuarantee,
              vesselPublicKey,
              vesselSecretKey,
            ),
            vesselSpecialConditions: encrypt(
              vessel?.vesselSpecialConditions,
              vesselPublicKey,
              vesselSecretKey,
            ),
          };
          await vesselServices.update(payload, vesselId);
        }

        response = await vesselServices?.associateUser(
          vesselId,
          userEmail,
          keys,
          vessel?.sheetName,
        );

        dispatch(alertActions.setAlert(t(response), alertConstants.SUCCESS));
        setUserEmail("");
        toggle();
      }
    } catch (error) {
      dispatch(alertActions.setAlert(t(error), alertConstants.ERROR));
    }
    setIsApiLoading(false);
  };
  return (
    <Modal show={show && !isLoading} onHide={toggle}>
      <Modal.Header closeButton>
        <span className={classes?.modalTitle}>{t("Associate user")}</span>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>{t("Enter user E-mail")}</Form.Label>
            <Form.Control
              type="email"
              placeholder={"example@domain.fr"}
              required
              name="userEmail"
              value={userEmail}
              onChange={handleChange}
              className={classes["email-control"]}
            />
          </Form.Group>
          <Button onClick={handleSubmit} disabled={isApiLoading}>
            {t("Associate")}
            {isApiLoading && <Spinner animation="grow" size="sm" />}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
